import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { BodyContainer, MainContainer } from '../HostBilling.styles';
import BillingInvoice from 'views/AdminPanel/BillingInvoice/BillingInvoice';
import { useParams } from 'react-router-dom'; // Import useParams
import ViewByUnits from 'views/AdminPanel/BillingInventory/components/ViewByUnits/ViewByUnits';
import moment from 'moment';
import { getHostById } from 'utils/apis/host';
import HostGeneralDetails from './HostGeneralDetails';

const { TabPane } = Tabs;

const HostDetails = ({ match }) => {
  const hostId = match.params.id; // 'id' corresponds to the dynamic part of your route
  const [host, setHost] = useState({});

  useEffect(() => {
    const fetchHost = async () => {
      try {
        const host = await getHostById(hostId);
        setHost(host.data);
        console.log(host.data);
      } catch (error) {
        console.error('Error fetching host:', error);
      }
    };

    fetchHost(); // Call the async function
  }, [hostId]);

  const getCsvFileName = () => {
    const defaultFileName = 'Inventory Reporting';
    const stringMonthYear = moment().format('MMM YYYY');
    const defaultFileNameWithMonthYear = `${stringMonthYear} - ${defaultFileName}`;

    const fileName = !!host.name ? `${host.name} - ${defaultFileNameWithMonthYear}` : `${defaultFileNameWithMonthYear}`;

    return `${fileName}.csv`;
  };

  return (
    <BodyContainer>
      <MainContainer>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Invoice" key="1" style={{ marginLeft: 0, marginRight: 0 }}>
            <BillingInvoice noUrlModification={true} host={hostId} />
          </TabPane>
          <TabPane tab="Inventory" key="2">
            <ViewByUnits hostId={hostId} monthWithYear={moment().format('YYYY-MM')} getCsvFileName={getCsvFileName} fromHostDetails={true} />
          </TabPane>
          <TabPane tab="Summary" key="3">
            {/* Content for Summary Tab */}
            Summary content goes here.
          </TabPane>
          <TabPane tab="Host Details" key="4">
            {/* Content for General Details Tab */}
            <HostGeneralDetails hostId={hostId} />
          </TabPane>
        </Tabs>
      </MainContainer>
    </BodyContainer>
  );
};

export default HostDetails;
